import script from "./StatementType.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementType.vue?vue&type=script&setup=true&lang=js"

import "./StatementType.vue?vue&type=style&index=0&id=1e034b16&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e034b16"]])

export default __exports__